import $ from "jquery";
// import autocomplete from "autocompleter";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useLocation, NavLink, useNavigate } from "react-router-dom";
import {
  setRegion,
  headerData,
  logout,
  fetchAllProductsData,
  NotificationCount,
} from "../redux/actions";
import CompanySelectionModal from "./modals/CompanySelectionModal";

const HeaderOne = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [region, setRegions] = useState(
    useSelector((state) => state?.region?.region)
  );

  const user = useSelector((state) => state?.user_data?.user_data);

  //const category = user?.company?.category;
  const user_region = user?.company?.currency?.value;
  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState(region);

  useEffect(() => {
    const user_region = user?.company?.currency?.value;
    if (user_region !== undefined && user_region !== null) {
      setRegions(user_region);
      dispatch(setRegion(user_region));
      setSelectedCurrency(user_region);
    }
  }, [user, dispatch]);

  //const languageoptions = [{ value: "Eng", label: "English" }];

  const options = [
    { value: "OMR", label: "Oman" },
    { value: "QAR", label: "Qatar" },
    // { value: "SAR", label: "Saudi Arabia" },
    { value: "AED", label: "United Arab Emirates" },
  ];
  const [showModal, setShowModal] = useState(false);

  //global search
  const searchParams = new URLSearchParams(location.search);
  const [searchValues, setSearchValue] = useState(
    searchParams.get("search_keyword") ? searchParams.get("search_keyword") : ""
  );
  const [sugesstion, setsugesstion] = useState([]);

  //used to set search value only in search screen. in other screens, search value will be removed.
  useEffect(() => {
    const current_path = location.pathname.split("/")[1];

    if (
      current_path !== "undefined" &&
      current_path !== "" &&
      current_path !== "search"
    ) {
      setSearchValue("");
    }

    if (current_path === "/") {
      setTimeout(() => {
        setSearchValue("");
      }, 100);
    }
  }, [location]);

  // useEffect(() => {
  //   var input = document.getElementById("search_result");

  //   if (input) {
  //     autocomplete({
  //       input: input,
  //       fetch: function (text, update) {
  //         text = text.toLowerCase();

  //         //const suggestions = sugesstion.filter(item => item.label.toLowerCase().includes(text.toLowerCase()));
  //         const suggestions = sugesstion.filter((item) =>
  //           item.label.toLowerCase().includes(text)
  //         );
  //         update(suggestions);
  //       },
  //       className: "autocomplete-customization",
  //       disableAutoSelect: true,
  //       onSelect: function (item) {
  //         setSearchValue(item.label);
  //       },
  //     });
  //   }
  // }, [sugesstion, searchValues]);

  const submitSearch = (e) => {
    if (e.key !== "Enter") return;
    e.preventDefault();

    if (!searchValues) {
      toast.error(
        "You have not specified search term. Please write something into search box to get started!"
      );
      return;
    }

    let company_id = "";
    let company_user_id = "";

    if (user?.name) {
      company_id = user?.company?.id;
      company_user_id = user?.id;
    }
    navigate(
      `/search?search_keyword=${encodeURIComponent(
        searchValues
      )}&company_id=${company_id}&company_user_id=${company_user_id}`
    );
  };
  async function callback_search_data(search_key) {
    const suggestions = await fetchAllProductsData(search_key);

    var suggestion_data = [];

    if (suggestions?.search_res?.length > 0) {
      suggestion_data = suggestions.search_res.map((value) => ({
        label: value.name,
        value: value.name,
      }));
    }
    //console.log('suggestion_data ', suggestion_data);
    setsugesstion(suggestion_data);
  }

  // Set the default language
  // const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  //   const handleLanguageChange = (language) => {
  //     setSelectedLanguage(language);
  //   };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);

  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  const [rfqListLength, setRfqListLength] = useState(0);
  const [notifyLength, setNotifyLength] = useState(0);

  useEffect(() => {
    const fetchNotifyCount = async () => {
      if (user?.company?.id) {
        const notify_count = await NotificationCount(user?.company?.id);
        //console.log("notify_count  ", notify_count);
        if (notify_count) {
          setNotifyLength(notify_count.general_notification_count);
        }
      }
    };

    fetchNotifyCount();
  }, [user]);

  useEffect(() => {
    const updateRfqListLength = () => {
      const rfqList = JSON.parse(localStorage.getItem("rfq_list")) || [];
      setRfqListLength(rfqList.length);
    };

    // Initial fetch
    updateRfqListLength();

    // Listen for the custom event
    window.addEventListener("rfqListUpdated", updateRfqListLength);

    return () => {
      window.removeEventListener("rfqListUpdated", updateRfqListLength);
    };
  }, []);

  const handleLogout = (event) => {
    event.preventDefault(); // Prevents default navigation
    dispatch(logout()); // Dispatch logout action
    navigate("/login"); // Redirect to login page after logout
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await headerData(); // Calling API function
        setData(result.menus); // Storing data in state
      } catch (err) {
        console.log("Failed to fetch data!");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = $(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  const handleRegionChange = useCallback(
    (e) => {
      dispatch(setRegion(e.target.value)); // Dispatch action
      setRegions(e.target.value);
      setSelectedCurrency(e.target.value);

      window.location.reload(); // Hard reload the page
    },
    [dispatch]
  );

  useEffect(() => {
    // Re-bind events manually if using plugins like Select2
    $(".js-example-basic-single").on("change", handleRegionChange); // This assumes jQuery or equivalent is being used

    return () => {
      // Clean up if necessary (optional)
      $(".js-example-basic-single").off("change", handleRegionChange);
    };
  }, [handleRegionChange]);

  if (
    location.pathname.includes("/self-service") &&
    (typeof user.name === "undefined" || !user.name || user.name === "Error")
  ) {
    navigate("/logout");
  }

  const [comparisonListLength, setComparisonListLength] = useState(0);

  useEffect(() => {
    const updateComparisonListLength = () => {
      const comparisonList =
        JSON.parse(localStorage.getItem("comparison_list")) || [];
      setComparisonListLength(comparisonList.length);
    };

    // Initial fetch
    updateComparisonListLength();

    // Listen for the custom event
    window.addEventListener(
      "comparisonListUpdated",
      updateComparisonListLength
    );

    return () => {
      window.removeEventListener(
        "comparisonListUpdated",
        updateComparisonListLength
      );
    };
  }, []);

  //cart count
  const cartCount = useSelector((state) => state.cart_count?.cartCount) ?? 0;

  return (
    <>
      {showModal && (
        <CompanySelectionModal
          onClose={() => setShowModal(false)}
          tokenList={user?.other_company_detail}
        />
      )}
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for a product or brand"
              name="search"
              id="search_result"
              autoComplete="off"
              value={searchValues}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={submitSearch}
              onKeyUp={(e) => callback_search_data(e.target.value)}
            />
            <button
              type="submit"
              onClick={submitSearch}
              className="w-48 h-48 bg-main-600-external rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}
      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="/assets/images/logo/dhofar-logo.svg" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start */}
            <ul className="nav-menu flex-align nav-menu--mobile">
              {/* Home Menu */}
              <li className="nav-menu__item">
                <Link to="/" className="nav-menu__link">
                  Home
                </Link>
              </li>
              <li className="nav-menu__item">
                {!user?.name && (
                  <Link to="/become-a-customer" className="nav-menu__link">
                    Self Service
                  </Link>
                )}
              </li>
              {user?.name && (
                <li className="nav-menu__item">
                  <Link to="/self-service/dashboard" className="nav-menu__link">
                    Dashboard
                  </Link>
                </li>
              )}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link to="/self-service/orders" className="nav-menu__link">
                    Orders
                  </Link>
                </li>
              )}{" "}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link
                    to="/self-service/apply-for-credit"
                    className="nav-menu__link"
                  >
                    Credit
                  </Link>
                </li>
              )}{" "}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link
                    to="/self-service/agreedproducts"
                    className="nav-menu__link"
                  >
                    Agreed Products
                  </Link>
                </li>
              )}{" "}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link to="/self-service/mycompany" className="nav-menu__link">
                    Company
                  </Link>
                </li>
              )}{" "}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link to="/self-service/profile" className="nav-menu__link">
                    Me
                  </Link>
                </li>
              )}{" "}
              {user?.name && (
                <li className="nav-menu__item">
                  <Link to="/self-service/users" className="nav-menu__link">
                    Users
                  </Link>
                </li>
              )}
              {/* <li className="nav-menu__item">
                <Link to="/about-us" className="nav-menu__link">
                  About us
                </Link>
              </li> */}
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}
      {/* ======================= Middle Top Start ========================= */}
      <div className="header-top header_main flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                {!user?.name && (
                  <Link
                    to="/become-a-customer"
                    className="text-white text-sm hover-text-decoration-underline"
                  >
                    Self Service
                  </Link>
                )}
              </li>
              {/* <li className="border-right-item">
                <Link
                  to="/about-us"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About us
                </Link>
              </li> */}
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              {user?.name && (
                <li className="border-right-item">
                  <Link
                    to="/self-service/dashboard"
                    className="text-white text-sm hover-text-decoration-underline"
                  >
                    Self Service
                  </Link>
                </li>
              )}
              {/* <li className="on-hover-item border-right-item border-right-item-sm-space arrow-white">
        
                <Link to="#" className="selected-text text-white text-sm py-8">
                  {selectedLanguage}
                </Link>
                <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  {languageoptions.map((option) => (
                    <li key={option.value}>
                      <Link
                        to="#"
                        className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        onClick={() => handleLanguageChange(option.label)}
                      >
                        <img
                          src={`/assets/images/thumbs/flag_${option.value.toLowerCase()}.png`}
                          alt={`${option.label} flag`}
                          className="w-16 h-12 rounded-4 border border-gray-100"
                        />
                        {option.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li> */}
              <li className="on-hover-item border-right-item border-right-item-sm-space arrow-white">
                {/* Display the selected currency  Removed from above has-submenu */}
                <Link to="#" className="selected-text text-white text-sm py-8">
                  {selectedCurrency}
                </Link>
                {/* <ul className="selectable-text-list on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  {options.map((option) => (
                    <li key={option.value}>
                      <Link
                        to="#"
                        className="hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        onClick={() => handleLanguageChange(option.value)}
                      >
                        <img
                          src={`/assets/images/thumbs/flag_${option.value.toLowerCase()}.png`}
                          alt={`${option.label} flag`}
                          className="w-16 h-12 rounded-4 border border-gray-100"
                        />
                        {option.value}
                      </Link>
                    </li>
                  ))}
                </ul> */}
              </li>
              {user?.name && user?.name !== "Error" && (
                <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                  <Link
                    to={user ? "#" : "/login"}
                    className="text-white text-sm py-8 flex-align gap-6"
                  >
                    <span className="icon text-md d-flex">
                      {" "}
                      <i className="ph ph-user-circle" />{" "}
                    </span>
                    <span className="hover-text-decoration-underline">
                      {user?.name ? `Hi, ${user.name}!` : "Login / Register"}
                    </span>
                  </Link>
                  {user ? (
                    <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                      {user?.other_company_detail &&
                        user?.other_company_detail?.length > 0 && (
                          <li className="nav-submenu__item">
                            <Link
                              className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                              onClick={async () => {
                                if (
                                  window.confirm(
                                    "Are you sure want to change the company?"
                                  )
                                ) {
                                  setShowModal(true);
                                }
                              }}
                            >
                              Company Swap
                            </Link>
                          </li>
                        )}
                      <li className="nav-submenu__item">
                        <Link
                          to="/logout"
                          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                          onClick={() => handleLogout}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
              )}
              {!user?.name && (
                <li className="border-right-item">
                  {!user?.name && (
                    <Link
                      to="/login"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="icon text-md d-flex">
                        {" "}
                        <i className="ph ph-user-circle" />{" "}
                      </span>
                      <span className="hover-text-decoration-underline">
                        Login / Register
                      </span>
                    </Link>
                  )}
                  {user?.name && (
                    <Link
                      to="/self-service/dashboard"
                      className="text-white text-sm py-8 flex-align gap-6"
                    >
                      <span className="hover-text-decoration-underline">
                        Hi, {user?.name}!
                      </span>
                    </Link>
                  )}
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}
      {/* ======================= Middle Header Start =========================     <header className="header-middle bg-color-one border-bottom border-gray-100">*/}
      <header className="header-middle bg-light-grey border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="/assets/images/logo/dhofar-logo.svg" alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* form location Start */}
            <form
              action="#"
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44 " //  className="search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44 text-xl "
                    placeholder="Search for a product or brand"
                    name="search"
                    id="search_result"
                    autoComplete="off"
                    value={searchValues}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyDown={submitSearch}
                    onKeyUp={(e) => callback_search_data(e.target.value)}
                  />
                  <button
                    type="submit"
                    onChange={submitSearch}
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                  >
                    <i className="ph ph-magnifying-glass" />
                  </button>
                </div>
              </div>
              <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100">
                <span className="text-gray-900 text-xl d-xs-flex d-none">
                  <i className="ph ph-map-pin" />
                </span>
                <div className="line-height-1">
                  <span className="text-gray-600 text-xs"> Location</span>
                  <div className="line-height-1">
                    {user_region ? (
                      // Read-only field without border and white background
                      <input
                        // type="text"
                        className="px-3 py-2"
                        search-form__input
                        common-input
                        py-13
                        ps-16
                        pe-18
                        rounded-pill
                        pe-44
                        text-xl
                        value={
                          options.find((option) => option.value === user_region)
                            ?.label || ""
                        }
                        readOnly
                        style={{ border: "none", background: "white" }}
                      />
                    ) : (
                      // Normal dropdown when category is not set
                      <select
                        onChange={handleRegionChange}
                        className="js-example-basic-single border border-gray-200 border-end-0"
                        name="state"
                        value={region}
                      >
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
              </div>
            </form>
            {/* form location start */}
            {/* Header Middle Right start */}
            <div className="header-right flex-align d-lg-block d-none">
              <div className="flex-align flex-wrap gap-12">
                <button
                  type="button"
                  className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                    <i className="ph ph-magnifying-glass" />
                  </span>
                </button>

                {user?.company?.id && (
                  <Link
                    to="/self-service/user-notification"
                    className="flex-align gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-bell" />
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                        {notifyLength}
                      </span>
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      {/* Notification */}
                    </span>
                  </Link>
                )}

                <Link to="/comparison" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-arrows-left-right" />

                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {comparisonListLength}
                    </span>
                  </span>
                </Link>

                <Link to="/rfq" className="flex-align gap-4 item-hover">
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-clipboard-text" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {rfqListLength}
                    </span>
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex"></span>
                </Link>
                <Link
                  to="/cart/one-time"
                  className="flex-align gap-4 item-hover"
                >
                  <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                    <i className="ph ph-shopping-cart-simple" />
                    <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                      {cartCount}
                    </span>
                  </span>
                  <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex"></span>
                </Link>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}
      {/* ==================== Header Start Here ==================== */}
      {!location.pathname.includes("/self-service") && (
        <header
          className={`header bg-white border-bottom border-gray-100 ${
            scroll && "fixed-header"
          }`}
        >
          <div className="container container-lg">
            <nav className="header-inner d-flex justify-content-between gap-8">
              <div className="flex-align menu-category-wrapper">
                {/* Category Dropdown Start */}
                <div className="category on-hover-item">
                  <button
                    onClick={handleCategoryToggle}
                    type="button"
                    className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                  >
                    <span className="icon text-2xl d-xs-flex d-none">
                      <i className="ph ph-dots-nine" />
                    </span>
                    <span className="d-sm-flex d-none">All</span> Categories
                    <span className="arrow-icon text-xl d-flex">
                      <i className="ph ph-caret-down" />
                    </span>
                  </button>
                  <div
                    className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${
                      activeCategory && "active"
                    }`}
                  >
                    <button
                      onClick={() => {
                        handleCategoryToggle();
                        setActiveIndexCat(null);
                      }}
                      type="button"
                      className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                    >
                      {" "}
                      <i className="ph ph-x" />{" "}
                    </button>
                    {/* Logo Start */}
                    <div className="logo px-16 d-lg-none d-block">
                      <Link to="/" className="link">
                        <img
                          src="/assets/images/logo/dhofar-logo.svg"
                          alt="Logo"
                        />
                      </Link>
                    </div>
                    {/* Logo End */}
                    <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                      {data &&
                        data.length > 0 &&
                        data.map((heading, index) => (
                          <li
                            key={index}
                            onClick={() => handleCatClick(index)}
                            className={`has-submenus-submenu ${
                              activeIndexCat === index ? "active" : ""
                            }`}
                          >
                            <Link
                              onClick={() => setActiveIndexCat(index)}
                              to="#"
                              className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                            >
                              <span>{heading?.name}</span>
                              <span className="icon text-md d-flex ms-auto">
                                <i className="ph ph-caret-right" />
                              </span>
                            </Link>

                            <div
                              className={`submenus-submenu py-16 ${
                                activeIndexCat === index ? "open" : ""
                              }`}
                            >
                              <h6 className="text-lg px-16 submenus-submenu__title">
                                {heading?.name}
                              </h6>
                              <ul className="submenus-submenu_ max-h-300 overflow-y-auto scroll-sm">
                                {heading?.menuItems[0]?.children?.map(
                                  (child, idx) => (
                                    <li key={idx}>
                                      <NavLink
                                        to={`/products/${child?.value?.en
                                          ?.split("/")
                                          .pop()}`}
                                        className={(navData) =>
                                          navData.isActive
                                            ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                                            : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                                        }
                                      >
                                        {child?.name}
                                      </NavLink>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                {/* Category Dropdown End  */}
                {/* Menu Start  */}
                <div className="header-menu d-lg-block d-none">
                  {/* Nav Menu Start */}
                  <ul className="nav-menu flex-align ">
                    &nbsp;
                    {data &&
                      data.length > 0 &&
                      data.map((heading) => (
                        <li className="on-hover-item nav-menu__item has-submenu">
                          <Link to="#" className="nav-menu__link">
                            {heading?.name}
                          </Link>
                          <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                            {heading?.menuItems[0]?.children &&
                              heading?.menuItems[0]?.children.map(
                                (child, index) => (
                                  <li
                                    key={index}
                                    className="common-dropdown__item nav-submenu__item"
                                  >
                                    <NavLink
                                      to={`/products/${child?.value?.en
                                        ?.split("/")
                                        .pop()}`}
                                      className={(navData) =>
                                        navData.isActive
                                          ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                                          : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                                      }
                                    >
                                      {child?.name}
                                    </NavLink>
                                  </li>
                                )
                              )}
                          </ul>
                        </li>
                      ))}
                  </ul>
                  {/* Nav Menu End */}
                </div>
                {/* Menu End  */}
              </div>
              {/* Header Right start */}
              <div className="header-right flex-align">
                <Link
                  to="#"
                  className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                >
                  <div className="d-flex text-32">
                    <i className="ph ph-phone-call" />
                  </div>
                  +971 6 530 2525
                </Link>
                <div className="me-16 d-lg-none d-block">
                  <div className="flex-align flex-wrap gap-12">
                    <button
                      onClick={handleSearchToggle}
                      type="button"
                      className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                        <i className="ph ph-magnifying-glass" />
                      </span>
                    </button>
                    <Link
                      to="/comparison"
                      className="flex-align gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                        <i className="ph ph-arrows-left-right" />

                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {comparisonListLength}
                        </span>
                      </span>
                    </Link>

                    <Link to="/rfq" className="flex-align gap-4 item-hover">
                      <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                        <i className="ph ph-clipboard-text" />
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {rfqListLength}
                        </span>
                      </span>
                      <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex"></span>
                    </Link>

                    <Link
                      to="/cart/one-time"
                      className="flex-align gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                        <i className="ph ph-shopping-cart-simple" />
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cartCount}
                        </span>
                      </span>
                      <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                        Cart
                      </span>
                    </Link>
                  </div>
                </div>
                <button
                  onClick={handleMenuToggle}
                  type="button"
                  className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
                >
                  {" "}
                  <i className="ph ph-list" />{" "}
                </button>
              </div>
              {/* Header Right End  */}
            </nav>
          </div>
        </header>
      )}

      {user?.name && location.pathname.includes("/self-service") && (
        <header
          className={`header bg-white border-bottom border-gray-100 ${
            scroll && "fixed-header"
          }`}
        >
          <div className="container container-lg">
            <nav className="header-inner d-flex justify-content-between gap-8">
              <div className="flex-align menu-category-wrapper">
                {/* Menu Start  */}
                <div className="header-menu d-lg-block d-none">
                  {/* Nav Menu Start */}
                  <ul className="nav-menu flex-align ">
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/dashboard"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/dashboard"
                        className="nav-menu__link"
                      >
                        DASHBOARD
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/orders"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/orders"
                        className="nav-menu__link"
                      >
                        ORDERS
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/apply-for-credit"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/apply-for-credit"
                        className="nav-menu__link"
                      >
                        CREDIT
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/agreedproducts"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/agreedproducts"
                        className="nav-menu__link"
                      >
                        AGREED PRODUCTS
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/mycompany"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/mycompany"
                        className="nav-menu__link"
                      >
                        COMPANY
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/profile"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link
                        to="/self-service/profile"
                        className="nav-menu__link"
                      >
                        ME
                      </Link>
                    </li>
                    <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/users"
                          ? "activePage"
                          : ""
                      }`}
                    >
                      <Link to="/self-service/users" className="nav-menu__link">
                        USERS
                      </Link>
                    </li>

                    {/* <li
                      className={`nav-menu__item ${
                        location.pathname === "/self-service/user-notification"
                          ? "activePage"
                          : ""
                      } ml-auto`}
                    >
                        <Link to="/self-service/user-notification" className="nav-menu__link">
                            NOTIFICATION
                        </Link>
                    </li> */}
                  </ul>
                  {/* Nav Menu End */}
                </div>

                {/* Menu End  */}
              </div>
              {/* Header Right start */}
              <div className="header-right flex-align">
                <div className="me-16 d-lg-none d-block">
                  <div className="flex-align flex-wrap gap-12">
                    <Link
                      to="/cart/one-time"
                      className="flex-align gap-4 item-hover"
                    >
                      <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                        <i className="ph ph-shopping-cart-simple" />
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cartCount}
                        </span>
                      </span>
                      <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                        Cart
                      </span>
                    </Link>
                  </div>
                </div>
                <button
                  onClick={handleMenuToggle}
                  type="button"
                  className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
                >
                  {" "}
                  <i className="ph ph-list" />{" "}
                </button>
              </div>
              {/* Header Right End  */}
            </nav>
          </div>
        </header>
      )}
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderOne;
